import { makeAutoObservable } from "mobx";
import { RootStore, ServiceStore } from "@intrasync/stores";
// import GenerateData from 'shared/generators/GenerateData'; // Adjust the path as necessary
// import { utils } from 'shared/intrasyncUtils';
import { utils } from 'shared/intrasyncUtils';
// import { ScheduleGridDateRange } from 'types/ScheduleGridTypes';
import { getDateRange } from 'shared/intrasyncUtils';
import IFCTrackerLeftHeaderCell from "./IFCTrackerCells/IFCTracker.LeftHeaderCell";
import IFCTrackerRightHeaderCell from "./IFCTrackerCells/IFCTracker.RightHeaderCell";
import IFCTrackerRightBodyCell from "./IFCTrackerCells/IFCTracker.RightBodyCell";
import IFCTrackerLeftBodyCell from "./IFCTrackerCells/IFCTracker.LeftBodyCell";

class IFCTrackerStore {
  rootStore: RootStore;

  dateKey = "castingDate";

  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  get columnHeaders() {
    // console.log(
    //   'Getting column headers this.currentEntitiesMolds',
    //   this.currentEntitiesMolds
    // );
    const headersByMold = this.currentEntitiesMolds
      .filter((mold) => {
        if (!mold) {
          return false;
        }
        if (mold === "0") {
          return false;
        }
        if (mold.includes("MU")) {
          return false;
        }
        if (mold.includes("FBF")) {
          return false;
        }
        return true;
      })
      .map((mold) => {
        return {
          width: 200,
          title: mold,
          key: mold,
          headerKey: "moldNumber",
          component: IFCTrackerRightHeaderCell,
          bodyComponent: IFCTrackerRightBodyCell,
        };
      });
    // console.log('headersByMold', headersByMold);

    return [
      {
        width: 200,
        title: "Date",
        key: "castingDate",
        component: IFCTrackerLeftHeaderCell,
        bodyComponent: IFCTrackerLeftBodyCell,
      },
      ...headersByMold,
    ];
  }

  get currentEntitiesMolds() {
    return utils.sortByMold(
      utils.uniqueArray(
        this.entities
          .filter((entity) => entity.moldNumber && entity.moldNumber !== "0")
          .map((entity) => entity.moldNumber as string)
      ) as string[]
    );
  }

  get entities() {
    const panelStore = this.rootStore?.panelStore as ServiceStore;
    const routerStore = this.rootStore?.routerStore;
    if (!panelStore || !panelStore?.entities?.length) return [];
    if (!routerStore?.params?.jobNumber) return [];

    // console.log('panelStore.entities', panelStore.entities);
    const panels = panelStore.entities.slice().filter((panelPlantItem) => {
      if (!panelPlantItem.jobNumber) {
        // console.log('NO JOB NUMBER', panelPlantItem);
        return false;
      }
      return utils.isSameJobNumber(
        panelPlantItem.jobNumber as number | string,
        routerStore?.params?.jobNumber as number | string
      );
    });
    if (!panels.length) return [];
    const ifcStatusStore = this.rootStore.ifcStatusStore as ServiceStore;
    const entities = panels.map((panel) => {
      const foundIFCStatus = ifcStatusStore.entities.find(
        (ifcStatus) =>
          ifcStatus.markNumber === panel.markNumber &&
          ifcStatus.jobNumber === panel.jobNumber
      );

      if (!foundIFCStatus) return panel;

      return {
        ...panel,
        ifcStatus: foundIFCStatus,
      };
    });
    // console.log('IFCTrackerStore entities', entities);
    return entities;
  }

  get dateRange() {
    const dates = this.entities
      .filter(
        (entity) => entity.castingDate && entity.castingDate !== "1970-01-01"
      )
      .map((entity) => entity.castingDate as string)
      .sort();

    const startDate = dates[0];
    const endDate = dates[dates.length - 1];

    // console.log('trackerDateRange dates', dates);

    return getDateRange(startDate, endDate, { weekdays: true });
  }
}

export default IFCTrackerStore;
